import logoLight from "@/assets/logo-custom.png";
import logoDark from "@/assets/logo-dark.webp";

interface LogoProps {
  className?: string;
  variant?: "light" | "dark";
}

export const Logo = ({ className = "", variant = "dark" }: LogoProps) => {
  const logo = variant === "light" ? logoLight : logoDark;
  
  return (
    <img 
      src={logo} 
      alt="Corporate Car Wash Company" 
      className={`h-10 md:h-12 w-auto px-0 pb-0 pr-[3px] object-fill ${className}`}
    />
  );
};
